import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-absence-rule',
  templateUrl: './absence-rule.component.html',
  styleUrls: ['./absence-rule.component.scss']
})
export class AbsenceRuleComponent implements OnInit {
  button={}
  date=new Date();
  workSystem:[];
  absencedropdown:any=[];
  fromvalue:number=0;
  private handleError: HandleError;
  customDataSource: any;
  SpecificDays:boolean=false
  WeekDaysList:{}[]=[]
  addpopup:string=''
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
  typeDropDown:{}[]=[]
  //dropdown
  DurationWorkSystemDropDown:[];
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public Objects:ObjectsService,public gt:genericCustomStoreService,
    public httpErrorHandler: HttpErrorHandler,public translate:TranslateService) { 
    gt.seturl("AbsenceRule");
    gt.submit();
    this.handleError = httpErrorHandler.createHandleError('AbsenceRuleService');
    this.customDataSource = gt.customDataSource;
    this.setCellValueFromField=this.setCellValueFromField.bind(this);
    this.button=Objects.button;
    this.WeekDaysList=Objects.WeekDaysList
    this.gt.getdropdowndata("AbsenceRule/GetDropDown","DayRulesTypes").subscribe((data: {}[]) => {this.typeDropDown = data})

    //get dropdown
    this.absencedropdown=Objects.absenceRules;
    this.isSpecificDays=this.isSpecificDays.bind(this)
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }

  ngOnInit(): void {}
  updateRow(options:any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date
  }
  onInitNewRow(e:any){ 
    e.data.dateOfRegistration = this.date
    this.SpecificDays=false
    this.addpopup=this.translate.instant('tableinfo.addbutton')

   }

  setCellValueFromField(newdata:any,value:number,oldData:any){
   newdata.toDaysCount=value
   this.fromvalue=oldData.fromDaysCount
  }
  isSpecificDays(newData:any,value:any){
    newData.isSpecificDays=value
    this.SpecificDays=value
  }
  onEditingStart(e:any){
    this.SpecificDays=e.data.isSpecificDays?e.data.isSpecificDays:false
    this.addpopup=this.translate.instant('tableinfo.editbutton')

  }
 

  onEditorPreparing(e:any) {
    if (e.parentType === "dataRow"  && e.dataField === "isSpecificDays") {
      e.editorName = "dxCheckBox"          
      e.editorOptions.value = e.value || false; 
      e.editorOptions.onValueChanged = function (args:any) {
        e.setValue(args.value); 
      }         
  }  
  
  if( e.parentType === "dataRow" && e.dataField === "fromDaysCount") {
    e.editorOptions.disabled = e.row.data && this.SpecificDays == true;
    }
    if( e.parentType === "dataRow" && e.dataField === "toDaysCount") {
      e.editorOptions.disabled = e.row.data && this.SpecificDays == true;
    }
    if( e.parentType === "dataRow" && e.dataField === "specificDayIs") {
      e.editorOptions.disabled = e.row.data && this.SpecificDays == false;
    }
    this.gt.onEditorPreparing(e)
}

addrowfun(name:string){
  return this.gt.addrow(name)
}
}